import { Expose, Type, Exclude } from 'class-transformer';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { SnObjectInfo } from '../base';
import { SnAuditOperation } from './audit-operation';

export class SnAudit extends SnModel {
  @Expose()
  public id: string;

  @Expose({ name: 'orgId' })
  public organizationId: string;

  @Expose({ name: 'orgName' })
  public organizationName: string;

  @Expose()
  @Type(() => SnObjectInfo)
  public user: SnObjectInfo;

  @Expose()
  @Type(() => SnObjectInfo)
  public userOrganization: SnObjectInfo;

  @Expose()
  public operation: SnAuditOperation;

  @Expose()
  @Type(() => SnObjectInfo)
  public object: SnObjectInfo;

  @Expose()
  @Type(() => SnObjectInfo)
  public objectOrganization: SnObjectInfo;

  @Expose()
  @Type(() => SnObjectInfo)
  public location: SnObjectInfo;

  @Expose()
  @Type(() => SnObjectInfo)
  public floor: SnObjectInfo;

  @ExposeRawData({ name: 'detail' })
  public details: Record<string, any>;

  @Expose()
  public ip: string;

  @Expose()
  @Type(() => SnObjectInfo)
  public shareOrganization: SnObjectInfo;

  @Expose({ name: 'timestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public createdAt: Date;

  @Expose({ name: 'updatedTimestamp' })
  @Type(() => Date)
  public updatedAt: Date;

  @Expose()
  public duration: number;

  @Expose()
  public notes: any[];

  @ExposeRawData()
  public changeData: any;

  constructor(data: any) {
    super();

    this.fromJSON(data);
  }
}
